import { B2BLayout } from '@/views/Auth/components';
import { withAuth, withSeo } from '@/views/Auth/hocs';
import { getServerSideI18nProps } from '@/views/Auth/utils';

import { LoginForm } from './components';
import translations from './i18n';

const B2BLogin = () => {
  return (
    <B2BLayout>
      <LoginForm />
    </B2BLayout>
  );
};

export const getServerSideProps = getServerSideI18nProps({
  pageKey: 'b2b-login',
  translations,
});

export default withSeo(withAuth(B2BLogin, { authenticated: false }));
